import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueCookie from 'vue-cookie';
import './lib/clipboard';
import JElementUI from '@jdcloud/jelement-next';
import JElementBiz from "@jdcloud/jelement-biz";
import "@jdcloud/jelement-biz/dist/theme-default/index.css";
import bizEnLocale from "@jdcloud/jelement-biz/dist/locale/lang/en";
import bizCnLocale from "@jdcloud/jelement-biz/dist/locale/lang/zh-CN";
import CloudidLib from '@jd/cloudid_frontend';

import enLocale from '@jdcloud/jelement-next/lib/locale/lang/en';
import zhLocale from '@jdcloud/jelement-next/lib/locale/lang/zh-CN';
import myZh from '@/common/i18n/zh-CN';
import myEn from '@/common/i18n/en-US';

import store from '@/store';
import { GET_GLOBALCONFIG, GET_REGIONS, GET_USERINFO} from '@/store/mutation-types';
import router from '@/router';
import menuChecker from '@/router/menuChecker';
import directives from '@/directives';
import filters from '@/filters';
import App from '@/App';
import '../static/css/jd.css';
import { CookieConstant, I18nConstant } from '@/common/Constants'
// import jdirective from '@jdcloud/jelement-next/packages/popover/src/directive';

Vue.prototype.GLOBALCOOKIE = CookieConstant.JDCLOUD_SITELANG;
// Vue.directive('popover', jdirective);

Object.keys(directives).forEach((key) => {
  console.log('[main.js] apply custom directive: %s', key);
  Vue.directive(key, directives[key]);
});
Object.keys(filters).forEach((key) => {
  console.log('[main.js] apply custom filter: %s', key);
  Vue.filter(key, filters[key]);
});

Vue.use(VueCookie);

const messages = {
  en: {
    ...myEn,
    ...enLocale
  },
  zh: {
    ...myZh,
    ...zhLocale
  }
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: VueCookie.get(Vue.prototype.GLOBALCOOKIE) || 'cn',
  fallbackLocale: 'zh',
  messages, // set locale messages
  silentTranslationWarn: true
});

Vue.use(JElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
// let BUILD_ENV = process.argv.splice(2)[0];
let BUILD_ENV = process.env.BUILD_ENV;
console.log('BUILD_ENV');
console.log(BUILD_ENV);
console.log(process.env.BUILD_ENV);
let JElementBizConfig;
// JElementBizConfig = {
//   locale: VueCookie.get(Vue.prototype.GLOBALCOOKIE) === I18nConstant.CN
//   || VueCookie.get(Vue.prototype.GLOBALCOOKIE) === null ?  bizCnLocale : bizEnLocale,
// }
if (BUILD_ENV === 'prod') {
  JElementBizConfig = {
    locale: VueCookie.get(Vue.prototype.GLOBALCOOKIE) === I18nConstant.CN
    || VueCookie.get(Vue.prototype.GLOBALCOOKIE) === null ?  bizCnLocale : bizEnLocale,
  }
} else {
  JElementBizConfig = {
    locale: VueCookie.get(Vue.prototype.GLOBALCOOKIE) === I18nConstant.CN
    || VueCookie.get(Vue.prototype.GLOBALCOOKIE) === null ?  bizCnLocale : bizEnLocale,
    env: 'stag'
  } 
}

Vue.use(JElementBiz, JElementBizConfig);

Vue.use(CloudidLib, {
  prodType: [
    {
      type: CloudidLib.PROD_COMMON,
      modules: ['filters']
    }
  ],
  fixDropdown: true,
  locale: VueCookie.get(Vue.prototype.GLOBALCOOKIE)
});
menuChecker(router);

store.dispatch(GET_GLOBALCONFIG);
store.dispatch(GET_REGIONS);
store.dispatch(GET_USERINFO);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  i18n
});



// WEBPACK FOOTER //
// ./src/main.js